import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { useDarkmode } from "hooks/useTheme";
import ManageStaffForm from "./manage-staff-form";

const ManageStaffDrawer = ({ isOpen, onClose, user, getStaffList }) => {
  const { darkmode } = useDarkmode();
  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose}>
        <ModalOverlay
          bg={darkmode ? "#A3AED080" : "#2B367480"}
          backdropFilter="blur(3px)"
          zIndex={15}
          onClick={() => onClose()}
        />
        <DrawerContent
          containerProps={{ zIndex: 20 }}
          className="my-2 ml-0 mr-4 w-[calc(100vw_-_32px)] max-w-[calc(100vw_-_32px)] rounded-2xl bg-white shadow-[-20px_17px_40px_4px_rgba(112,_144,_176,_0.18)] dark:bg-background-900 dark:shadow-[-22px_32px_51px_4px_#0B1437] sm:ml-4 md:w-[600px] md:max-w-[600px]"
        >
          <DrawerCloseButton className="absolute right-4 top-4 text-xs p-3 text-gray-900 dark:text-white" />

          <DrawerHeader className="px-8 pt-6">
            <div className="font-bold text-xl text-gray-800 dark:text-white">
              Manage Staff
            </div>
          </DrawerHeader>
          <DrawerBody className="flex-1 px-8 my-6 overflow-auto">
            <ManageStaffForm
              onClose={onClose}
              user={user}
              getStaffList={getStaffList}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default ManageStaffDrawer;
